import { render, staticRenderFns } from "./UpcomingScheduledMessagesList.vue?vue&type=template&id=47abe66e&scoped=true&"
import script from "./UpcomingScheduledMessagesList.vue?vue&type=script&lang=js&"
export * from "./UpcomingScheduledMessagesList.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingScheduledMessagesList.vue?vue&type=style&index=0&id=47abe66e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abe66e",
  null
  
)

export default component.exports